import * as React from 'react';
import { observer } from 'mobx-react';
import { ChangeHistoryWorkflowApprove } from 'nomst/Stores/ChangeHistory/changeHistoryWorkflowApprove';
import {
    ChangeHistoryWorkflowSubmitOrSendBack
} from 'nomst/Stores/ChangeHistory/changeHistoryWorkflowSubmitOrSendBack';
import { ChangeHistoryItem } from 'typings/enums';
import { formatTimestamp } from 'utils/dateUtils';

export interface IChangeHistoryWorkflowActivityViewProps {
    changeHistoryWorkflowEntry: ChangeHistoryWorkflowApprove | ChangeHistoryWorkflowSubmitOrSendBack | null;
    timestamp: string;
}

export class ChangeHistoryWorkflowActivityView extends React.Component<IChangeHistoryWorkflowActivityViewProps> {
    render(): React.ReactNode {
        const { changeHistoryWorkflowEntry, timestamp } = this.props;
        if (!changeHistoryWorkflowEntry) {
            return null;
        }

        return (
            <div className="history-item flex-row">
                <div className="history-workflow-icon">
                    {this.renderIcon()}
                </div>
                <div className="history-item-content">
                    <div className="flex-row history-top">
                        <span>{formatTimestamp(timestamp)}</span>
                    </div>
                    {this.renderHistoryItem(changeHistoryWorkflowEntry)}
                    <div className="row flex-row" />
                </div>
            </div>
        );
    }

    private renderHistoryItem(
        changeHistoryWorkflowEntry: ChangeHistoryWorkflowApprove
            | ChangeHistoryWorkflowSubmitOrSendBack): React.ReactNode {
        if (changeHistoryWorkflowEntry.code === ChangeHistoryItem.ChangeHistoryWorkflowApprove) {
            return this.renderWorkflowActivityApprove();
        }

        return this.renderWorkflowActivitySendOrSubmit();
    }

    private renderWorkflowActivityApprove(): React.ReactNode {
        const { changeHistoryWorkflowEntry } = this.props;
        const changeHistory = changeHistoryWorkflowEntry as ChangeHistoryWorkflowApprove;
        return (
            <div>
                <strong className="display-name">
                    {changeHistory.approvedBy.displayName}
                </strong> approved this team&apos;s decisions
            </div>
        );
    }

    private renderWorkflowActivitySendOrSubmit(): React.ReactNode {
        const { changeHistoryWorkflowEntry } = this.props;
        const changeHistory = changeHistoryWorkflowEntry as ChangeHistoryWorkflowSubmitOrSendBack;

        if (changeHistoryWorkflowEntry?.code === ChangeHistoryItem.ChangeHistoryWorkflowSubmit) {
            return (
                <div>
                    <strong className="display-name">{changeHistory.modifyingUser.displayName}</strong>
                sent this team to <strong>{changeHistory.reviewerDisplayName}</strong> for review
                </div>
            );
        }

        return (
            <div>
                <strong className="display-name">{changeHistory.modifyingUser.displayName}</strong>
               sent this team back to <strong>{changeHistory.reviewerDisplayName}</strong> for review
            </div>
        );
    }

    private renderIcon(): React.ReactNode {
        const { changeHistoryWorkflowEntry } = this.props;
        if (changeHistoryWorkflowEntry?.code === ChangeHistoryItem.ChangeHistoryWorkflowApprove) {
            return (
                <i className="icon-thumbs-up pxl-text-c9" />
            );
        }

        if (changeHistoryWorkflowEntry?.code === ChangeHistoryItem.ChangeHistoryWorkflowSendBack) {
            return (
                <i className="icon-lock-open-alt pxl-text-c10" />
            );
        }

        if (changeHistoryWorkflowEntry?.code === ChangeHistoryItem.ChangeHistoryWorkflowSubmit) {
            return (
                <i className="icon-flipped icon-paper-plane" />
            );
        }

        return null;
    }
}

export default (observer(ChangeHistoryWorkflowActivityView));